export const generateTableHead = () => [
  { title: 'Domain', access: true },
  { title: 'User', access: true },
  { title: 'Status', access: true },
  { title: 'Created', access: true },
  { title: 'Expiry', access: true },
  { title: '', access: true },
].filter((item) => item.access);

export const generateTableBody = (item) => [
  { type: 'domain', value: item.domain, access: true },
  { type: 'user', value: item.user, access: true },
  { type: 'status', value: item.status_name, access: true },
  { type: 'created', value: item.created, access: true },
  { type: 'expiry', value: item.expiry, access: true },
  { type: 'actions', value: null, class: 'td-caret', access: true },
].filter((item) => item.access);

/**
 * @name itemDropStatuses
 * @param statuses {Array} - Список всех статусов для страницы
 * @param itemAccess {Array} - Список доступных статусов для одного элемента теблицы
 * @param t {Function} - Функция для переводов
 */
export const itemDropStatuses = (statuses, itemAccess = [], t) => {
  if (itemAccess === false) {
    return [];
  }
  return statuses?.filter((item) => itemAccess.includes(item.id)).map((elem) => ({ id: elem.id, title: t(`ActionsList.${elem.title}`) }));
};

export const getItemActions = (item, access) => [
  {
    title: 'Cancel and refund',
    id: 1,
    access: item?.access?.cancel && access?.cancel,
  },
].filter((item) => item.access);

/**
 * @name prepareConfirmBtnsText
 * @param actionKey {String} - Ключ события
 * @param actionType {Number} - Тип события
 */
export const prepareConfirmBtnsText = (actionKey) => {
  switch (actionKey) {
  case 1:
    return {
      confirmBtnText: 'Cancel and refund',
      cancelBtnText: 'Close',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};
